"use client";
import Breadcrumbs from "@/components/Breadcrumbs";
import React from "react";
import AdSection from "@/components/AdSection";

import { toast } from "react-hot-toast";
import Link from "next/link";
import MessagesReceived from "@/components/ClientComponents/MessagesReceived";

export default function FreeTempNumberClient({ data }) {
  const copyToClipboard = (number: string) => {
    navigator.clipboard.writeText(number);
    toast.success("Number Copied");
  };

  return (
    <>
      <div className="py-4 lg:py-14 space-y-6">
        <Breadcrumbs
          capitalizeLinks
          countryCode={`+${data.countries.country_tel_code}`}
        />

        <div className="flex lg:flex-row flex-col items-start justify-between space-x-1 space-y-4 lg:space-y-0">
          <div className="w-full lg:w-[44%]  space-y-3">
            <h1 className="w-full  font-bold text-2xl">
              {data.countries.country_name} Free Temporary SMS Number
            </h1>

            <div className="flex items-center space-x-1">
              <h2 className="font-spaceGrotesk font-bold text-3xl">
                +{data.countries.country_tel_code}-{data.number}
              </h2>
              <div
                onClick={() => {
                  copyToClipboard(
                    `+${data.countries.country_tel_code}${data.number}`
                  );
                }}
                className="p-2 hover:bg-gray-100 cursor-pointer rounded-full"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-6 w-6 md:w-8 md:h-8"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
                  />
                </svg>
              </div>
            </div>
            <p className="text-gray-600 font-medium">
              Use this free SMS {data?.countries?.country_name} number +
              {data.countries.country_tel_code}-{data.number} for verifications
              and 2FA. A mic icon means the numbers supports 2FA (two factor
              authentication) by voice.
            </p>
          </div>
          <div className="text-sm space-y-4 p-8 text-gray-700  border-[#090EDB] border-[2px] w-full lg:w-[40%] rounded-xl h-auto">
            <h3 className="font-bold text-lg"> Message not received? </h3>
            <p>
              If you didn&#39;t receive the message you were expecting in the Messages Received section below, it&#39;s
              likely the service or platform you are using has blocked the
              number. Consider{" "}
              <Link href="/rent-private-number" className="underline">
                renting your own dedicated private number
              </Link>{" "}
              which will work with all platform and services.
            </p>
            <div className="flex items-center justify-center">
              <Link href="/rent-private-number">
                <div
                  className={`bg-gradient-to-tr from-[#090EDB] to-[#E73DC4] hover:bg-gradient-to-tr hover:from-[#090EDB]/80 hover:to-[#E73DC4]/80 px-10 transition-all duration-300 hover:px-14 py-3 text-white font-semibold rounded-lg`}
                >
                  Rent VIP Private Number
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="mt-8 space-y-4">
          <h2 className="font-semibold text-2xl">
            How to Use This Temporary {data.countries.country_name} Number
          </h2>
          <p className="text-zinc-600 font-medium">
            <strong>Follow these simple steps to receive your free SMS online:</strong>
          </p>
          <ol className="list-decimal list-inside text-zinc-600 font-medium space-y-1">
            <li>
              Copy the number and paste it into any service that asks you for a
              phone verification.
            </li>
            <li>
              Wait a few seconds and your message will appear automatically on
              this page, like magic.
            </li>
            <li>
              You can use the same number again or pick another temporary phone
              number whenever you need it.
            </li>
          </ol>
          <p className="text-zinc-600 font-medium">
            Want to be the only one to see your verification code?{" "}
            <Link href="/rent-private-number" className="underline">
              Rent a private virtual number
            </Link>
            .
          </p>
        </div>
      </div>

      <div className="py-8 ">
        <AdSection />

        <MessagesReceived endpoint="/api/messages/free" />

        <AdSection />
      </div>
    </>
  );
}
